"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AWSImage_1 = __importDefault(require("components/design-system/AWSImage"));
const Avatar_1 = __importDefault(require("components/design-system/Avatar"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const ProfileType = ({ isTeam, user, team, title, subtitle = '', customClass, statusComponent, titleClassName = '', subtitleClassName = '', onClick, size, truncateSubtitle = true, srcPicture, tooltipClassContainer = '' }) => {
    const [showTitleTooltip, setShowTitleTooltip] = (0, react_1.useState)(false);
    const titleRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if ((titleRef?.current?.scrollWidth || 0) >
            (titleRef?.current?.clientWidth || 0)) {
            setShowTitleTooltip(true);
        }
    }, []);
    return (react_1.default.createElement("div", { className: `flex w-full ${customClass ? customClass : ''}` },
        react_1.default.createElement(Avatar_1.default, { src: srcPicture ? srcPicture : user?.profilePicture, name: user?.name, statusComponent: statusComponent, onClick: onClick, size: size }),
        react_1.default.createElement("div", { className: `flex ${!subtitle ? 'items-center' : 'flex-col'} ml-[16px] overflow-hidden` },
            react_1.default.createElement(TooltipContainer_1.default, { show: showTitleTooltip, position: "bottom", text: title, key: 0, useMaxWidth: false, classContainer: `${tooltipClassContainer}` },
                react_1.default.createElement("p", { ref: titleRef, "data-cy": "title", className: `typography-h500 overflow-hidden truncate ${titleClassName}` }, title)),
            isTeam ? (react_1.default.createElement("div", { className: "flex" },
                team?.teamPicture && (react_1.default.createElement(AWSImage_1.default, { className: "team-picture rounded-[4px] w-[16px] h-[16px] mr-[4px]", src: team.teamPicture })),
                react_1.default.createElement("p", { className: "typography-h100 typography-secondary" }, `${team?.name} · ${user.role}`))) : truncateSubtitle ? (react_1.default.createElement(TruncateParagraph_1.default, { className: `${subtitleClassName
                    ? subtitleClassName
                    : 'typography-paragraph typography-secondary'}`, dataCy: "sub-title" }, subtitle)) : (subtitle && (react_1.default.createElement("p", { className: `${subtitleClassName
                    ? subtitleClassName
                    : 'typography-paragraph typography-secondary'} max-w-full` }, subtitle))))));
};
exports.default = ProfileType;
